<template lang="en">
<div class="footer row">
    <div class="col-sm-12 col-lg-3 d-flex flex-column justify-content-center align-items-start ">
        
        <img class="logo mt-5 mt-lg-0" src="@/assets/logo.svg" />
    </br>
    </div>
    <div class="col-sm-12 col-lg-2 d-flex flex-column justify-content-center align-items-start">
        <h3 class="title">{{$t('address')}}</h3>
        <a style="text-align:start; color:white" href="https://www.google.com/maps/place/40%C2%B022'35.9%22N+49%C2%B049'43.6%22E/@40.376612,49.8285976,19z/data=!4m4!3m3!8m2!3d40.3766389!4d49.8287778?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoASAFQAw%3D%3D" 
        target="_blank" v-html="$t('address_split')"/>
    </br>
    </div>
    <div class="col-sm-12 col-lg-2 d-flex flex-column justify-content-center align-items-start">
        <h3 class="title">{{$t('contacts')}}</h3>

        <a style="text-align:start; color:white" href="mailto:info@ibacademy.az">info@ibacademy.az</a>
        
        <p>
            +994 51 244 58 77
        </p>
        <p >
            +994 51 244 62 81
        </p>
        <p>
            +994 51 244 62 83
        </p>
        
    </div>
    <div class="col-sm-12 col-lg-1 d-flex flex-lg-column flex-sm-row justify-content-center align-items-center py-5">
        <a href="https://www.linkedin.com/company/ib-academy-baku/" class="social-button" target="_blank">
            <img src="@/assets/linkedin.svg" />
        </a>
        <a href="https://www.facebook.com/ib.academy.baku" class="social-button" target="_blank">
            <img src="@/assets/facebook.svg" />
        </a>
        <a href="https://www.instagram.com/ib.academy.az/" class="social-button" target="_blank">
            <img src="@/assets/instagram.svg" />
        </a>
        <a href="https://www.tiktok.com/@ib.academy.az" class="social-button" target="_blank">
            <img src="@/assets/tiktok.svg" />
        </a>
        <a href="https://www.threads.net/@ib.academy.az" class="social-button" target="_blank">
            <img src="@/assets/threads.svg" />
        </a>

    </div>
    <img class="background-logo d-none col-4 d-lg-block" src="@/assets/logo_only.svg" />
</div>
</template>

<script>
export default {
}
</script>

<style lang="css">
.footer {
    min-height: 100px;
    background-color: #222222;
    color: #fff;
    border-radius: 30px 30px 0 0;
    padding-left: 40px;
    padding-right: 20px;
}

.title {
    font-weight: bold;
    text-align: start;
}


.social-button {
    margin: 15px;
}

.background-logo {
    align-self: stretch;
    height: 92%;
    bottom: 0;
    right: 0;
    z-index: 0;

}

.relative {
    position: relative;
}

.logo {
    height: 60px;

}
</style>
